export default {
  headline: 'Kanály notifikácií',
  subheadline: 'Nakonfigurujte kanály notifikácií prístupom k jednému z nich',
  headerType: 'Typ kanála',
};
